import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * "תלמידים אחרונים" — up to 10 students sorted by last activity across
 * every event source (app_open, clip_view, attempt, passed, progress).
 * Row: initial avatar · name · activity kind · relative time. Footer
 * link jumps to the full students screen.
 */
import React from 'react';
import { Avatar, Empty, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { CardShell } from './CardShell';
import { PALETTE, formatRelativeTimeHe, initial, kindLabelHe } from './helpers';
const { Text } = Typography;
export function RecentStudentsCard({ data, loading, error, onReload }) {
    const students = data?.students ?? [];
    return (_jsx(CardShell, { title: "\u05EA\u05DC\u05DE\u05D9\u05D3\u05D9\u05DD \u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD", loading: loading && students.length === 0, error: error, onReload: onReload, skeletonRows: 6, bodyStyle: { padding: 0 }, extra: _jsx(Link, { to: "/users", style: { fontSize: 13, color: PALETTE.purpleDeep }, children: "\u05DC\u05DB\u05DC \u05D4\u05EA\u05DC\u05DE\u05D9\u05D3\u05D9\u05DD" }), children: students.length === 0 ? (_jsx("div", { style: { padding: 16 }, children: _jsx(Empty, { description: "\u05D0\u05D9\u05DF \u05E4\u05E2\u05D9\u05DC\u05D5\u05EA \u05E2\u05D3\u05D9\u05D9\u05DF", image: Empty.PRESENTED_IMAGE_SIMPLE }) })) : (_jsx("ul", { style: { listStyle: 'none', margin: 0, padding: 0 }, children: students.map((s) => _jsx(Row, { s: s }, s.id)) })) }));
}
function Row({ s }) {
    const name = (s.display_name && s.display_name.trim()) || s.email;
    return (_jsxs("li", { style: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 16px',
            borderTop: `1px solid ${PALETTE.gridLine}`,
        }, children: [_jsx(Avatar, { size: 36, src: s.avatar_url || undefined, style: {
                    background: PALETTE.lavAlt,
                    color: PALETTE.purpleDeep,
                    fontWeight: 600,
                    fontSize: 15,
                    flex: '0 0 auto',
                }, children: initial(name) }), _jsxs("div", { style: { minWidth: 0, flex: 1 }, children: [_jsx(Text, { style: { display: 'block', fontWeight: 500, color: PALETTE.ink }, ellipsis: true, children: name }), _jsx(Text, { style: { fontSize: 12, color: PALETTE.inkMuted }, children: kindLabelHe(s.last_activity_kind) })] }), _jsx(Text, { style: { fontSize: 12, color: PALETTE.inkMuted, flex: '0 0 auto' }, children: formatRelativeTimeHe(s.last_activity_at) })] }));
}
